import { useAuth } from "contexts/auth";
import React, { useState, useEffect, useRef } from "react";
import { enviaToken, IBuscaClienteOut, IValidaTokenIn, validaToken } from "services/2FA/2FA";
import styled from "styled-components";
import secureLocalStorage from "react-secure-storage";
import { Else, If, Then } from "react-if";
import { CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTracking } from "contexts/tracking";
import { enableBodyScroll } from "utils/scroll-lock";
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";
import { useRecaptchaField } from "contexts/recaptchaField";
import { AcaoEvento } from "services/TrackingService";
import { SituacaoCredor } from "pages/Login";
import ModalTentativas from "./ModalTentativas";

interface ModalProps {
  isOpen: boolean;
  onSubmit?: (method: 'E-mail' | 'SMS') => void;
  cliente: IBuscaClienteOut | undefined;
  nomeCliente?: string;
  setOpenCredorNotFound: (state: SituacaoCredor) => void;
  setSubmitting: (state: boolean) => void
  realizarLogin: (trackId: string | undefined) => void
  onClose?: () => void
}

export default function Modal2FA({ isOpen: modalIsOpen, cliente, realizarLogin, onClose, setSubmitting }: ModalProps) {
  const [tokenPendenteEnvio, setTokenPendenteEnvio] = useState(true);
  const [selectedMethod, setSelectedMethod] = useState('SMS');
  const [selectedContact, setSelectedContact] = useState<string>('');
  const [listaContato, setListaContato] = useState<string[]>([]);
  const timeOut = 60 * 3;
  const [seconds, setSeconds] = useState(timeOut);
  const [canResend, setCanResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tokenArray, setTokenArray] = useState(new Array(4).fill(""))
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const { trackId } = useParams<{ trackId: string | undefined}>()
  const { sendTracking } = useTracking();
  const { reset: recaptchaReset } = useRecaptchaField();

  const clienteTemTelefone: boolean = cliente !== undefined && Array.isArray(cliente.telefones) && cliente.telefones.length > 0;
  const clienteTemEmail: boolean = cliente !== undefined && Array.isArray(cliente.emails) && cliente.emails.length > 0;

  const [openTentativas, setOpenTentativas] = useState(false);

  useEffect(
    () => {
      if (selectedMethod === "SMS" && cliente?.telefones) {
        setListaContato(cliente?.telefones)
      }
      if (selectedMethod === "E-mail" && cliente?.emails) {
        setListaContato(cliente?.emails)
      }
    }, [selectedMethod, cliente]
  )

  useEffect(() => {
    if (modalIsOpen) {
      setSelectedMethod('SMS');
      setSelectedContact('');
      setCanResend(false);
    }
  }, [modalIsOpen]);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(
        () => {
          setSeconds((prev) => prev - 1);
        }, 1000);
      return () => clearInterval(timer);
    }
    else {
      setCanResend(true);
    }
  }, [seconds]);

  const handleSubmitToken = async () => {
    try {
      sendTracking({trackId, acao: AcaoEvento.TokenEnviado, cpfCnpj: cliente?.cpfCnpj,});
      await enviaToken(selectedContact, cliente?.internalToken);
      setTokenPendenteEnvio(false);
      setSeconds(timeOut);
      setCanResend(false);
  } 
    catch (error: any) {

      if (error.response?.status === 429) {
        setOpenTentativas(true);
        return;
      }
  };
}

  if (!modalIsOpen) return null;

  const handleInputOnChange = (idx: number, e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    const newTokenArray = [...tokenArray]
    newTokenArray[idx] = value
    setTokenArray(newTokenArray)
  }

  const fecharModal2FA = () => {
    let Modal2FA = document.getElementById("overlay-modal-2fa") as HTMLDialogElement
    enableBodyScroll(document.body)
    Modal2FA.classList.remove("open")
    setTokenPendenteEnvio(true);
    onClose && onClose();

    recaptchaReset();
  }

  return (
    <Overlay id="overlay-modal-2fa" className="">
      <ModalTentativas
        open={openTentativas}
        onClose={() => setOpenTentativas(false)}
      />
      <ModalContainer>
        <ModalTitle>
          <h2>Token de autenticação</h2>
          <Button color="inherit" style={{padding: 0, minWidth: 0}} onClick={fecharModal2FA}><CloseIcon/></Button>
        </ModalTitle>

        {
          tokenPendenteEnvio ?
            (
              <>
                <TextContainer>
                  <p>Para sua segurança, precisamos confirmar que você é realmente você, e por isso te enviaremos um token de autenticação.</p>
                  <p>Selecione qual a forma de contato pelo qual você receberá o seu token para autenticação:</p>
                </TextContainer>

                <ContactOptionSelect>
                  <ButtonGroup>

                    {
                      clienteTemTelefone &&
                      (
                        <OptionButton
                          method='SMS'
                          onClick={async () => {
                            setSelectedMethod('SMS')
                          }}
                        >
                          Enviar por SMS
                        </OptionButton>
                      )
                    }
                    {
                      clienteTemEmail &&
                      (
                        <OptionButton
                          method='E-mail'
                          onClick={async () => {
                            setSelectedMethod('E-mail')
                          }}
                        >
                          Enviar por E-Mail
                        </OptionButton>
                      )
                    }

                  </ButtonGroup>

                  <FormListaContato className={selectedMethod ? "visible" : "hidden"}>
                    <div className="contactoptions">

                      {
                        listaContato.map(
                          (contact, idx) => (
                            <ContactOption key={idx}>
                              <input
                                key={idx}
                                type="radio"
                                value={contact}
                                checked={selectedContact === contact}
                                onChange={(e) => setSelectedContact(e.target.value)}
                              />

                              <FakeRadio>
                                <span />
                              </FakeRadio>

                              <p>{contact}</p>

                            </ContactOption>
                          )
                        )
                      }

                    </div>

                    <ButtonGroup>
                      <ConfirmButton
                        disabled={!selectedContact}
                        onClick={
                          async () => {
                            handleSubmitToken()
                          }
                        }
                      >
                        Enviar token
                      </ConfirmButton>
                    </ButtonGroup>
                  </FormListaContato>
                </ContactOptionSelect>
              </>
            )
            :
            (
              <>
                <InsertToken>
                  <div className="containerInsertToken">
                    <p className="paragafoInsertToken">Digite abaixo o token que foi enviado para o contato {selectedContact}:</p>
                  </div>
                </InsertToken>


                <EnvioTokenConteiner>
                  <GrupoInput>
                    {
                      tokenArray.map(
                        (inputValue, idx) => (
                          <TokenInput
                            key={idx}
                            ref={(input) => { inputRefs.current[idx] = input; }}
                            pattern="\d*"
                            maxLength={1}
                            inputMode="numeric"
                            onChange={(e) => handleInputOnChange(idx, e)}
                            onKeyDown={
                              (e) => {
                                if (
                                  !/[\d]/.test(e.key) &&
                                  e.key !== 'Backspace' &&
                                  e.key !== 'Delete' &&
                                  e.key !== 'Tab' &&
                                  e.key !== 'Enter'
                                ) {
                                  e.preventDefault();
                                }
                              }
                            }
                            onKeyUp={
                              (e) => {
                                if (e.key === 'Backspace') {
                                  inputRefs.current[idx - 1]?.focus()
                                  inputRefs.current[idx - 1]?.select()
                                }
                                if (/[\d]/.test(e.key)) {
                                  inputRefs.current[idx + 1]?.focus()
                                  inputRefs.current[idx + 1]?.select()
                                }
                              }
                            }
                          />
                        )
                      )
                    }
                  </GrupoInput>

                  <CountDownSectiom>
                    {
                      canResend ?
                        (
                          <BotaoReenviarToken onClick={handleSubmitToken}>
                            Reenviar Token
                          </BotaoReenviarToken>
                        )
                        :
                        (
                          <p className="secondParagraph">Aguarde {seconds > 0 ? seconds : 0} segundos para reenviar o token.</p>
                        )
                    }
                  </CountDownSectiom>

                  <ButtonGroup>
                    <BackButton
                      disabled={seconds > 0}
                      onClick={() => setTokenPendenteEnvio(true)}
                    >
                      Voltar
                    </BackButton>
                    <ConfirmButton
                      disabled={tokenArray.join('').length != 4 || loading}
                      onClick={
                        async () => {
                          const validaTokenIn: IValidaTokenIn = {
                            trackId: "",
                            appId: process.env.REACT_APP_ID,
                            internalToken: cliente?.internalToken,
                            token: tokenArray.join('')
                          }

                          setLoading(true)
                          sendTracking({ trackId, acao: AcaoEvento.Autenticacao2FA, cpfCnpj: cliente?.cpfCnpj });
                          await validaToken(validaTokenIn)
                            .then(
                              async (data) => {
                                if (data != undefined) {
                                  secureLocalStorage.setItem("@token", data.token)
                                  await realizarLogin(trackId)
                                  enableBodyScroll(document.body)
                                }
                              }
                            )
                            .finally(
                              () => {
                                setLoading(false)
                                setSubmitting(true)
                                fecharModal2FA()
                              }
                            )

                        }
                      }
                    >
                      <If condition={loading}>

                        <Then>
                          <CircularProgress size={12 + 1} />
                        </Then>

                        <Else>
                          Prosseguir
                        </Else>

                      </If>

                    </ConfirmButton>
                  </ButtonGroup>
                </EnvioTokenConteiner>
              </>
            )
        }
      </ModalContainer>
    </Overlay >
  );
};

const ModalTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
`

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 1rem;
  overflow-y: auto;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.15s, visibility 0.15s;

  &.open {
    z-index: 50;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
`;

const CountDownSectiom = styled.div`
  height: 6rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  margin: 1rem;
  background-color: #fff;
  border-radius: 0.5rem;
  max-width: 28rem;
  width: 100%;

  max-height: 90vh;
  overflow-y: auto;

  font-family: Poppins-Regular, Helvetica, sans-serif;

  .contactoptions {
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    border: 1px solid #E4E5E5;
    padding: 1rem;
    max-height: 12rem;
    overflow-y: auto;
    gap: 1rem;
  }

  @media (max-width: 480px) {
    margin: 0.5rem;
    border-radius: 0.75rem;
  }

  transition: all .15s;
`;

const TextContainer = styled.div`
  border-top: 0.0625rem solid #CED4DA;
  border-bottom: 0.0625rem solid #CED4DA;
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  font-size: 1rem;

  @media (max-width: 480px) {
    padding: 1rem;
    font-size: 0.95rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

const ConfirmButton = styled.button`
  padding: 0.625rem;
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  margin-left: auto;
  width: 40%;
  
  &:disabled {
    background-color: #DEE2E6;
    cursor: not-allowed;
  }
  
  &:enabled:hover {
    background-color: #208638;
  }

  transition: background-color .1s;
`;

const BackButton = styled.button`
  background-color: transparent;
  border: none;
  font-size: 0.75rem;
  height: 2.25rem;
  cursor: pointer;
  color: #585858;
  font-weight: 600;
  
  &:hover {
    color: #000000;
  }
  
  &:disabled {
    cursor: not-allowed;
    color: #727272;
    
    &:hover {
      color: #727272;
    }
  }

  transition: color .1s;
`;

const OptionButton = styled.button<{ method: 'E-mail' | 'SMS' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.625rem 1.25rem;
  line-height: 1.3rem;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  background-color: ${(props) => (props.method === 'SMS' ? "#FE6F59" : "#ACAFB2")};
  color: #ffffff;
  width: 100%;
  height: 2.5rem;
  border-radius: 8px;

  &:hover {
    background-color: ${(props) => (props.method === 'SMS' ? "#e55a50" : "#9E9E9E")};
  }

  @media screen and (max-width: 459px) {
    height: 3.75rem;
  }

  transition: all .15s;
`;

const InsertToken = styled.div`
  padding: 0 2rem;

  display: flex;
  flex-direction: column;
  justify-content: center;

  border-top: 0.0625rem solid #CED4DA;
  border-bottom: 0.0625rem solid #CED4DA;

  .containerInsertToken{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .secondParagraph{
    font-size: 0.8125rem;
  }
`;

const BotaoReenviarToken = styled.button`
  margin: 0.625rem 0;
  font-size: 0.875rem;
  font-weight: 700;
  color: #FE6F59;
  background-color: transparent;
  border: none;
  cursor: pointer;
  
  &:hover {
    color: #cf513e;
  }

  transition: color .1s;
`;

const ContactOptionSelect = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const EnvioTokenConteiner = styled.div`
  padding: 2rem;
  text-align: center;
  gap: 1rem;

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

const GrupoInput = styled.div`
  display: flex;
  width: 100%;
  padding: 1rem;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  border: 1px solid #cfcfcf;

  @media (max-width: 360px) {
    gap: 0.5rem;
    padding: 0.75rem;
  }
`;

const TokenInput = styled.input`
  height: 2.5rem;
  width: 2.5rem;
  color: #707070;
  border: none;
  border-bottom: 1px solid #cfcfcf;
  border-radius: 8px 8px 0 0;

  &:focus {
    border-color: #bebebe;
    outline: 1px solid #FE6F59;
  }

  transition: border .15s;
  text-align: center;
  font-weight: 500;
  font-size: 1.125rem;
  cursor: pointer;

  @media (max-width: 360px) {
    width: 2.2rem;
    height: 2.2rem;
    font-size: 1rem;
  }
`;

const ContactOption = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  cursor: pointer;
  color: #111111;
  gap: 1rem;

  p {
    margin: 0;
  }

  input {
    display: none;
  }
`;

const FakeRadio = styled.span`
  border-radius: 50%;
  border: 1px solid #111111;
  height: 20px;
  width: 20px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    border-radius: 50%;
    display: block;
    width: 0;
    height: 0;
    transition: all .15s;
  }
  
  input:checked + & {
    
    span {
      width: 100%;
      height: 100%;
      background-color: #FE6F59;
    }
  }
`;

const FormListaContato = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 0;
  transition: max-height .15s, margin-top .15s, gap .15s, opacity .4s;
  
  gap: 0;
  opacity: 0;
  &.visible {
    margin-top: 1rem;
    max-height: 15rem;
    gap: 1rem;
    opacity: 1;
  }
`;

